import { AppSettings } from "./app-settings";

export const passthroughUrls: Array<string> = [
    AppSettings.apiUrl + "users/uistate",
    AppSettings.apiUrl + "token",    
    AppSettings.apiUrl + "resetpassword/verifyusername",
    AppSettings.apiUrl + "resetpassword/sendotp",
    AppSettings.apiUrl + "resetpassword/verifyotp",
    AppSettings.apiUrl + "resetpassword",
    AppSettings.apiUrl + "pushnotification/deletedevice",
    AppSettings.apiUrl + "settings",
    AppSettings.apiUrl + "parents/wards",
    AppSettings.apiUrl + "users/getloggedinuser",
    AppSettings.apiUrl + "users/login",
    AppSettings.apiUrl + "users/googlelogin"
];